import React, { Component } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import { styled } from '@mui/system';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


export default class Navigationanddatagrids extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logredirect: false, pagename: '',bs_id:0,type:'',adminarray:[],label: 'Select Name',desc: '',
      redirect: false,bsid:'',ids:'',textcountmin:0,errormessage:'',Navigationdata:[],
textcountmax:200, successMessage: '',submitbtn:'save',
      showSuccessMessage: false,
    };
  }




   
componentWillMount() {
	
	document.title = "Navigation&Grid data";
	
	if(localStorage.getItem("ISIuserid")==null)
		  {

		 this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		 this.props.parentdasCallback(
            "Navigation and data grids ~"
        );
	this.apicall();
	     

} 
apicall() {
  let strset = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=6'+'&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data.length > 0) {
        resp.data.map((row, i) => {
          const items = {
            bs_id: row.bs_id,
            bs_title: row.bs_title,
            bs_value:row.bs_value, 
            bs_page: row.bs_page,
		 };

          strset.push(items);
        });

     
        this.setState({
          Navigationdata: strset,
        });
      } else {
        this.setState({Navigationdata: []});
      }

    });
}
   



  HandleNavigationSetting = (bs_id, index) => {
    return (event) => {
		const value = event.target.value; 
      const updatedData = [...this.state.Navigationdata];
      updatedData[index].bs_value = event.target.value;
      this.setState({ Navigationdata: updatedData });
    };
  }

	

  myChangeHandlerPV = (rows, bs_id) => {
    return (event) => {
      const updatedData = [...this.state.Navigationdata];
      updatedData[rows].bs_value = event.target.checked ? '1' : '0';
      this.setState({ Navigationdata: updatedData });
    };
  }







	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

  


    handleSubmit = (event) => {
    event.preventDefault();
      let optionsVals=this.state.Navigationdata;
    let sep1 = '';
    let optionValues = '';

	 
	  optionsVals.forEach(eachvals => {
     
		 optionValues=optionValues+sep1+eachvals.bs_id+"~"+eachvals.bs_value;
		 sep1="`"
		
		   
	   });
 
    const formData = new FormData();
	
	
	formData.append('action','Bulkupdate')
	 formData.append('business',optionValues)
	 formData.append('bs_page',6)
	 
	 
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('userid',localStorage.getItem("ISIuserid"))


    axios.post(localStorage.getItem("ISIurl")+'ajaxbusinesssetting.php', formData)
      .then((res) => {
      this.setState({
            btndisabled: false,
            submitbtn: "Save",
         
            errormessage: "Updated Successfully", 
            erropen: true,
            successMessage: ' updated successfully!',
            showSuccessMessage: true,
          });
      })
   
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
	<React.Fragment> 
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
      <div className="page-container">
  
  
  
  
    <div className="termsandcondition">
  <h3>NAVIGATION</h3>
  <p>Choose whether to use standard or advanced navigation.</p>
</div>

<div className="titleright">
  {this.state.Navigationdata.map((item, index) => (
    <React.Fragment key={index}>
       {item.bs_id === "1" && (
                  <FormControl className="preference">
                    <RadioGroup
                      value={item.bs_value}
                      onChange={this.HandleNavigationSetting(item.bs_id, index)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="Standard"
                        control={<Radio />}
                      label={
    <span style={{ fontWeight: 'bold' }}>
      Standard -{" "}
      <span style={{ fontWeight:400,marginLeft: '8px' }}>Best for business users(e.g. Contacts and Reporting in Seperate Sections). </span>
    </span>
  }
                      />
                      <FormControlLabel
                        value="Advanced"
                        control={<Radio />}
						
						  label={
    <span style={{ fontWeight: 'bold' }}>
      Advanced -{" "}
      <span style={{ fontWeight:400,marginLeft: '8px' }}>Best for accountants(e.g. Contacts and Reports together under Sales and Expenses).</span>
		  </span>
  }				
						
   
                      />
                    </RadioGroup>
                  </FormControl>  
       )}
    </React.Fragment>
  ))}
</div>
<div className="clear"></div>

   
   
   
      <div className="termsandcondition">
  <h3>TABLES OF DATA</h3>
  <p>Set how many rows of data you'd like to see in tables.</p>
</div>

<div className="titleright">
  
       {this.state.Navigationdata.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "2" && (
    
		<div>
 <span style={{marginLeft: '8px', fontWeight: 'bold' }}>Show me </span>		
	 <Select
				 native
				 variant="outlined" className="search"
				  margin="normal"
				  onChange={this.HandleNavigationSetting(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
					inputProps={{tabIndex: "4"}}
				>	
				
				
				 <option value={10}>10</option>
				<option value={25}>25</option>
			
			
				<option value={100}>100</option>
			</Select>	
			  <span style={{marginLeft: '8px', fontWeight: 'bold' }}> items in each table unless I override it.</span>
			</div>
     )}
	  </React.Fragment> 
  ))}
   
   </div>
   <div className="clear"></div>
   
   
 
       
   
   
   
       <div className="termsandcondition">
  <h3>TIMEZONE</h3>
  <p>Affects the date and time printed on PDF reports, for example.</p>
</div>

<div className="titleright">
  
               
   
    
    {this.state.Navigationdata.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "3" && (
    
		<div >
 <span style={{marginLeft: '8px',fontWeight: 'bold' }}>Selected Timezone </span>		
	 <Select
                  native
                  variant="outlined"
                  className="txtbox"
                  margin="normal"
                  onChange={this.HandleNavigationSetting(item.bs_id, index)}
                  id="bs_value"
                  value={item.bs_value}
                  name="bs_value"
                  inputProps={{ tabIndex: "4" }}
				 style={{width:'65%' }}
                > 
                <option value="Pacific/Midway">(UTC-12:00) - International Date Line West</option>
<option value="Pacific/Pago_Pago">(UTC-11:00) - Co-ordindated Universal Time-11</option>
<option value="Pacific/Honolulu">(UTC-10:00) - Hawaii</option>
<option value="America/Juneau">(UTC-09:00) - Alaska</option>
<option value="America/Los_Angeles">(UTC-08:00) - Baja California</option>
<option value="America/Los_Angeles">(UTC-08:00) - Pacific Time (US &amp; Canada)</option>
<option value="America/Chihuahua">(UTC-07:00) - Arizona, Chihuahua, La Paz, Mazatlan</option>
<option value="America/Denver">(UTC-07:00) - Mountain Time (MST)</option>
<option value="America/Mexico_City">(UTC-06:00) - Guadalajara, Mexico City, Monterrey, Saskatchewan</option>
<option value="America/Chicago">(UTC-06:00) - Central Time (US &amp; Canada)</option>
<option value="America/Bogota">(UTC-05:00) - Bogota, Lima, Quito, Indiana (East)</option>
<option selected="selected" value="America/New_York">(UTC-05:00) - Eastern Standard Time (US &amp; Canada)</option>
<option value="America/Caracas">(UTC-04:30) - Caracas</option>
<option value="America/Halifax">(UTC-04:00) - Asuncion, Atlantic Time, Cuiaba, Georgetown, San Juan</option>
<option value="America/St_Johns">(UTC-03:30) - Newfoundland</option>
<option value="America/Argentina/Buenos_Aires">(UTC-03:00) - Brasilia, Buenos Aires, Cayenne, Fortaleza, Greenland, Salvador</option>
<option value="Atlantic/South_Georgia">(UTC-02:00) - Co-ordinated Universal Time-2</option>
<option value="Atlantic/Cape_Verde">(UTC-01:00) - Cabo Verde Is.</option>
<option value="Europe/London">(UTC / GMT) - Dublin, Edinburgh, Lisbon, London</option>
<option value="Europe/Paris">(UTC+01:00) - Amsterdam, Berlin, Madrid, Paris</option>
<option value="Europe/Athens">(UTC+02:00) - Athens, Cairo, Helsinki, Istanbul, Pretoria</option>
<option value="Europe/Moscow">(UTC+03:00) - Baghdad, Kuwait, Minsk, Moscow, Nairobi</option>
<option value="Asia/Tehran">(UTC+03:30) - Tehran</option>
<option value="Asia/Muscat">(UTC+04:00) - Abu Dhabi, Baku, Muscat, Port Louis, Tbilisi, Yerevan</option>
<option value="Asia/Kabul">(UTC+04:30) - Kabul</option>
<option value="Asia/Karachi">(UTC+05:00) - Ashgabat, Islamabad, Karachi, Tashkent</option>
<option value="Asia/Kolkata">(UTC+05:30) - Chennai, Kolkata, Mumbai, New Delhi, Sri Jayawardenepura</option>
<option value="Asia/Kathmandu">(UTC+05:45) - Kathmandu</option>
<option value="Asia/Novosibirsk">(UTC+06:00) - Astana, Dhaka, Novosibirsk</option>
<option value="Asia/Bangkok">(UTC+07:00) - Bangkok, Hanoi, Jakarta, Krasnoyarsk</option>
<option value="Asia/Hong_Kong">(UTC+08:00) - Beijing, Chongqing, Hong Kong, Kuala Lumpur, Perth, Singapore, Taipai</option>
<option value="Asia/Tokyo">(UTC+09:00) - Osaka, Seoul, Tokyo, Yakutsk</option>
<option value="Australia/Adelaide">(UTC+09:30) - Adelaide, Darwin</option>
<option value="Australia/Sydney">(UTC+10:00) - Brisbane, Canberra, Guam, Hobart, Melbourne, Sydney, Vladivostok</option>
<option value="Pacific/Noumea">(UTC+11:00) - Chokurdakh, New Caledonia, Solomon Islands</option>
<option value="Pacific/Auckland">(UTC+12:00) - Auckland, Fiji, Wellington</option>
<option value="Pacific/Tongatapu">(UTC+13:00) - Nuku'alofa</option>
<option value="Pacific/Kiritimati">(UTC+14:00) - Kiritimati Island</option></Select>
               
              </div>
            )}
          </React.Fragment>
        ))}
   
   </div>
   <div className="clear"></div>
   
   
   
   
   
   
     <div className="termsandcondition">
  <h3>GETTING STARTED</h3>
  <p>Choose whether to display the getting started panel on the Summary page.</p>
   <p>This guide explores Accounting's top features and helps you to get things set up quickly and easily.</p>
</div>

<div className="titleright">
  {this.state.Navigationdata.map((rows, i) => (
    <React.Fragment key={rows.bs_id}>
	 {rows.bs_id === "4" && (
     <p><FormControlLabel
        label={
    <span style={{ fontWeight: 'bold' }}>
      Show the Getting Started panel
    </span>
  }
        control={ <Checkbox   name="bs_value" sx={{
  
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}value={rows.bs_value}onChange={this.myChangeHandlerPV(i, rows.bs_id)}
  checked={rows.bs_value === "1"}   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>

	 )}
    </React.Fragment>
  ))}
</div>
<div className="clear"></div>
 
  
		 <div className="salesaction">	
		 
        <Button
          type="submit"
          halfWidth
          variant="contained"
          color="primary"
          id="submit"
          className="frmSecondarybtn"
          onClick={this.handleSubmit}
          key="submitButton"
		  disabled={this.state.btndisabled}
        >
		{this.state.submitbtn}
        </Button>
		&nbsp;&nbsp;&nbsp;
		<Button variant="contained"  color="primary" className="frmSecondarybtn" onClick={this.onclickCancel}>
Cancel
</Button>
</div>

      </div>
	  </React.Fragment>
    );
  }
}